import React, { Component } from 'react';
import { withRouter, setCookie, setSearchCookie, getCookie, loginUrl, pocketUrl, LoadingSpinner, sleep } from './include/Common';
import $ from 'jquery';
import axios from "axios";
import Swiper from 'swiper';
import { Pagination, Autoplay, EffectFade } from 'swiper/modules';
import {Helmet} from 'react-helmet';

//
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';
import Footer from './Footer';

Swiper.use([Pagination, Autoplay, EffectFade]);

class WordView extends Component {
   constructor(props) {
      super(props);
      this.swiper = null;
      const stored = getCookie('searchHistory') || [];
      this.state = {
         searchKeyword: '',
         totalCount: 0,
         totalNewsCount: 0,
         wordData: '',
         relatedList: [],
         caseList: [],
         newsList: [],
         loading: true,
         showMore: false,
         page: 1,
         keyword: '',
         error: null
      };
   }

   addSearchHistory = (keyword) => {
      if (this.state.autoSave == 'on') {
         this.setState((prevState) => {
            const updated = [keyword, ...prevState.searchHistory.filter(k => k !== keyword)].slice(0, 10);
            setSearchCookie('searchHistory', updated, { path: '/' });
            return { searchHistory: updated };
         });
      }
   };

   componentDidMount() {
      const publicUrl = process.env.PUBLIC_URL;
      const sIdx = this.props.params.stext; // URL의 /Search/:stext 에 해당
      this.fetchWord(sIdx);
   }
   componentDidUpdate(prevProps, prevState) {
      if (
         prevState.caseList !== this.state.caseList &&
         this.state.caseList.length >= 2
      ) {
         this.initSwiper();
      }
   }

   async fetchWord(sIdx) {
      const publicUrl = process.env.PUBLIC_URL;
      // 예: axios 요청 가능
      try {
         sleep(1000);
         const wordRes = await axios.get('/api/getWord.php?idx=' + sIdx, { timeout: 10000 });
         const wordData = wordRes.data.word;
         const relatedData = wordRes.data.related;
         const caseData = wordRes.data.case;

         const relatedItems = Object.keys(relatedData)
            .filter(key => !isNaN(key))
            .map(key => relatedData[key]);

         const caseItems = Object.keys(caseData)
            .filter(key => !isNaN(key))
            .map(key => caseData[key]);

         const newsRes = await axios.get('/api/searchESmodule.php?keyword=' + wordData.t_term.trim() + '&pg=' + this.state.page);
         const newsData = newsRes.data;

         const newsItems = Object.keys(newsData)
            .filter(key => !isNaN(key))
            .map(key => newsData[key]);


         /*
      let relatedItems = [];
      if(!(relatedRes=== '' || relatedRes ==='undefined' || relatedRes ===undefined || relatedRes === null) ){
         relatedItems= relatedRes.data.t_related.split(",").map(item => item.trim());
      }
      */
         this.setState({
            searchKeyword: wordData.t_term,
            totalCount: wordData.total,
            wordData: wordData,
            relatedList: relatedItems,
            caseList: caseItems,
            newsList: newsItems,
            totalNewsCount: newsData.total,
            wordZzim: wordData.uzzim,
            showMore: newsData.total > 10 ? true : false,
            //wordList: wordItems,
            //newsList: newsItems,
            //relatedList: relatedRes.data,
            loading: false,
            //keyword: searchKeyword,
         });
      } catch (error) {
         this.setState({
            error: error.message,
            loading: false,
            //keyword: searchKeyword,
         });
      };
   }

   async fetchMoreNews(keyword, page) {
      const nextPage = page + 1;
      const publicUrl = process.env.PUBLIC_URL;
      const sKeyword = keyword.trim();
      try {
         const newsRes = await axios.get(`/api/searchESmodule.php?keyword=${sKeyword}&pg=${nextPage}`);
         const newsData = newsRes.data;
         const newsItems = Object.keys(newsData)
            .filter(key => !isNaN(key))
            .map(key => newsData[key]);

         this.setState(prevState => ({
            newsList: [...prevState.newsList, ...newsItems], // 기존 리스트에 추가
            page: nextPage,
            loading: false,
            showMore: newsData.total > (page * 10) ? true : false,
         }));
      } catch (error) {
         this.setState({
            error: error.message,
            loading: false,
         });
      }
   };
   handleSearchClick = (e) => {
      e.preventDefault(); // a 태그의 기본 동작 막기
      const { totalCount, totalNewsCount, wordList, newsList, loading, page, keyword, error } = this.state;
      this.props.navigate(`/Search/${encodeURIComponent(keyword)}`);
   }
   handleSearchChange = (e) => {
      this.setState({ keyword: e.target.value });
   }
   highlightTerm(text, keyword) {
      if (!keyword || !text) return text;

      const regex = new RegExp(`(${keyword})`, 'gi'); // 대소문자 무시
      return text.replace(regex, '<em>$1</em>');
   }
   handleButtonClick = async (idx) => {
      const element = document.getElementById(`zzimbtn`);
      const { wordZzim } = this.state;
      const isActive = wordZzim;
      let md = 'setZzim';
      if (isActive) {
         md = 'unsetZzim';
      }

      try {
         const ret = await setWord(md, idx);
         if (ret == 'setZzim') {
            element.className = 'zzim active';
            this.setState({ wordZzim: true });
         } else {
            element.className = 'zzim';
            this.setState({ wordZzim: false });
         }
      } catch (err) {
         console.error('버튼 클릭 처리 실패:', err);
      }
   };
   initSwiper() {
      if (this.swiper) this.swiper.destroy(true, true); // 기존 인스턴스 제거
      this.swiper = new Swiper(".word-usage-swiper .swiper-container", {
         loop: true,
         autoplay: {
            delay: 5000,
            disableOnInteraction: false
         },
         effect: "fade",
         fadeEffect: { crossFade: true },
         speed: 500,
         grabCursor: true,
         autoHeight: true,
         pagination: {
            el: ".word-usage-swiper .swiper-pagination",
            clickable: true
         }
      });

      const swiperEl = document.querySelector('.word-usage-swiper .swiper-container');

      const observer = new IntersectionObserver(
         (entries) => {
            entries.forEach((entry) => {
               if (entry.isIntersecting) {
                  // 보이면 작동
                  if (this.swiper.autoplay) this.swiper.autoplay.start();
                  this.swiper.update();
               } else {
                  // 안 보이면 정지
                  if (this.swiper.autoplay) this.swiper.autoplay.stop();
               }
            });
         },
         {
            threshold: 0.1,
         }
      );
      observer.observe(swiperEl);
   }

   render() {
      const { totalCount, totalNewsCount, searchKeyword, showMore, wordData, caseList, newsList, relatedList, loading, page, keyword, error } = this.state;

      const asiaeNewsUrl = process.env.REACT_APP_ASIA_WWW;
      const ogDesc = wordData.t_desc ? wordData.t_desc.split(/([.!?])/).slice(0, 2).join('').trim() : wordData.t_desc;
      const ogTitle = wordData?.t_term + ' - 지식포켓';
      const currentUrl = window.location.href;

      const structureData = {
         "@context": "https://schema.org",
         "@type": "WebSite",
         "name": ogTitle,
         "url": currentUrl,
      }      
      return loading ? <LoadingSpinner /> : (
         <>
            <Helmet>

               <title>{ogTitle}</title>
               <meta name="keywords" content="지식포켓, 뉴스 용어, 시사 용어, 오늘의 용어, 용어 검색, OX 퀴즈, 객관식 퀴즈, 십자말풀이, 시사 상식, 뉴스 해설, 용어 사전" />
               <meta name="description" content={ogDesc}/>

               <meta property="og:type" content="website" />
               <meta property="og:site_name" content="지식포켓" />
               <meta property="og:title" content={ogTitle} />
               <meta property="og:description" content={ogDesc}/>
               <meta property="og:url" content={currentUrl} />
               <meta property="og:image" content="https://cwstatic.asiae.co.kr/pocket/og_img.png" /> 
               <meta property="og:image:width" content="1200" />
               <meta property="og:image:height" content="630" />
               <meta property="og:locale" content="ko_KR" />

               <link rel="canonical" href={currentUrl}/>
               <script type="application/ld+json">
               { JSON.stringify(structureData)}
               </script> 

            </Helmet>         
            <main id="contents" data-page="word" className="page--word">
               <section className="section section--word">
                  <div className="title-bx">
                     <h1 className="tit"> 포켓 속 용어 </h1>
                  </div>
                  <></>
                  <div className="container">
                     <article className="word-card">
                        <button type="button" id="zzimbtn" className={wordData.uzzim ? 'zzim active' : 'zzim'} onClick={() => this.handleButtonClick(wordData.t_idx)}>
                           <svg width="24" height="22" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg" fillOpacity="0">
                              <use xlinkHref="#zzim"></use>
                           </svg>
                           <span className="sr-only"> 찜하기 해제 </span>
                        </button>

                        <div className="quote-wrap">
                           <svg width="16" height="12" viewBox="0 0 16 12"><use xlinkHref="#quote"></use></svg>
                           <svg width="16" height="12" viewBox="0 0 16 12"><use xlinkHref="#quote"></use></svg>
                           <p className="tit"> {wordData?.t_term} </p>
                           <p className="eng"> {wordData?.t_subtitle}</p>
                        </div>
                        <p className="desc">{wordData?.t_desc}</p>
                     </article>
                  </div>
               </section>
               <section className="section">
                  <div className="title-bx">
                     <h2 className="tit"> 활용 사례 </h2>
                  </div>

                  <div className="container">
                     <div className="word-usage-swiper">
                        <div className="swiper-container">
                           <div className="swiper-wrapper">
                              {(caseList && caseList.length > 0) ? (
                                 caseList.map((item, index) => {
                                    const cleanText = item.replace(/^\d+\.\s*/, '');
                                    return (
                                       <div className="swiper-slide item" key={index} dangerouslySetInnerHTML={{ __html: this.highlightTerm(cleanText, wordData?.t_term) }} />
                                    )
                                 })
                              ) : (
                                 <div className="no-result">
                                    검색 결과가 없습니다.
                                 </div>
                              )}
                           </div>
                           <div className="swiper-pagination" style={{ position: 'relative', bottom: 'auto', marginTop: '10px' }}></div>
                        </div>
                     </div>
                  </div>
               </section>
               <section className="section">
                  <div className="title-bx">
                     <h2 className="tit">
                        함께 보면 좋은 용어
                     </h2>
                  </div>
                  <div className="container">
                     <div className="word-bullet-list">
                        {(relatedList && relatedList.length > 0) ? (
                           relatedList.map((item, index) => (
                              <span key={index} class="word"># {item}</span>
                           ))
                        ) : (
                           <div className="no-result">
                              검색 결과가 없습니다.
                           </div>
                        )}
                     </div>
                  </div>
               </section>

               <section className="section">
                  <div className="title-bx d-flex">
                     <h2 className="tit">관련 기사</h2>
                     <p className="desc"> 총 <em>{totalNewsCount ? totalNewsCount : 0}</em>건 </p>
                  </div>
                  <div className="container">
                     <ul className="article-list">
                        {newsList.map((item, index) => {
                           const timg = item.t_img ? item.t_img.split('|')[0] : '';
                           const hasImage = !!timg;
                           const timgUrl = 'https://cwcontent.asiae.co.kr/asiaresize/120/' + timg;
                           return (
                              <li className="item" key={index}>
                                 <a href={`${asiaeNewsUrl}/article/${item.t_uid}`} target="_blank" className="link" title={item.t_title}>
                                    {hasImage && (
                                       <div className="img-bx">
                                          <img src={timgUrl} alt="" />
                                       </div>
                                    )}
                                    <div className="txt-bx">
                                       <p className="tit" dangerouslySetInnerHTML={{ __html: item.t_title }} />
                                    </div>
                                 </a>
                              </li>
                           );
                        })}
                     </ul>
                     {showMore ? (
                        <div className="article-list__more">
                           <button className="btn" title="더보기" onClick={() => this.fetchMoreNews(searchKeyword, page)}>
                              더보기
                              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                 <path d="M11.9999 7.71429H7.71416V12H6.28559V7.71429H1.99988V6.28571H6.28559V2H7.71416V6.28571H11.9999V7.71429Z" fill="black" stroke="black" />
                              </svg>
                           </button>
                        </div>
                     ) : <></>}
                  </div>
               </section>

               <section className="section">
                  <a href="/TodayCross" className="quiz-banner">
                     <div className="img-bx">
                        <svg width="95" height="95" viewBox="0 0 95 95" fill="none" xmlns="http://www.w3.org/2000/svg">
                           <path d="M32.9879 72.4679V88.6135C32.9879 90.387 33.609 91.8965 34.8511 93.1421C36.0967 94.3842 37.608 95.0053 39.385 95.0053H55.52C57.297 95.0053 58.8083 94.3842 60.0539 93.1421C61.296 91.8965 61.917 90.387 61.917 88.6135V72.4679C61.917 70.691 61.296 69.1797 60.0539 67.9341C58.8083 66.6919 57.297 66.0709 55.52 66.0709H39.385C37.608 66.0709 36.0967 66.6919 34.8511 67.9341C33.609 69.1797 32.9879 70.691 32.9879 72.4679ZM28.9238 55.615V39.48C28.9238 37.703 28.3028 36.1935 27.0607 34.9514C25.8186 33.7058 24.309 33.0829 22.5321 33.0829H6.39702C4.62007 33.0829 3.10878 33.7058 1.86316 34.9514C0.621053 36.197 0 37.7065 0 39.48V55.6203C0 57.3937 0.621053 58.9033 1.86316 60.1489C3.10878 61.391 4.61831 62.0121 6.39174 62.0121H22.5374C24.3143 62.0121 25.8256 61.391 27.0712 60.1489C28.3133 58.9033 28.9344 57.3937 28.9344 55.6203M39.385 62.0121H55.5253C57.3023 62.0121 58.8135 61.391 60.0592 60.1489C61.3013 58.9033 61.9223 57.3937 61.9223 55.6203V39.48C61.9223 37.703 61.3013 36.1935 60.0592 34.9514C58.8135 33.7058 57.3023 33.0829 55.5253 33.0829H39.3902C37.6133 33.0829 36.102 33.7058 34.8564 34.9514C33.6143 36.1935 32.9932 37.703 32.9932 39.48V55.6203C32.9932 57.3937 33.6143 58.9033 34.8564 60.1489C36.102 61.391 37.6133 62.0121 39.3902 62.0121M72.3676 29.0241H88.6083C90.3817 29.0241 91.8912 28.4031 93.1368 27.161C94.3789 25.9153 95 24.4058 95 22.6324V6.39702C95 4.62007 94.3789 3.10878 93.1368 1.86316C91.8947 0.621053 90.387 0 88.6135 0H72.3623C70.5889 0 69.0794 0.621053 67.8338 1.86316C66.5917 3.10878 65.9706 4.61831 65.9706 6.39174V22.6324C65.9706 24.4093 66.5917 25.9206 67.8338 27.1662C69.0794 28.4083 70.5907 29.0294 72.3676 29.0294" fill="white" />
                           <rect x="66" y="33" width="29" height="29" rx="6" fill="#00FF99" />
                        </svg>
                     </div>
                     <div className="txt-bx">
                        <p className="desc"> 십자말 풀이 퀴즈 풀고 </p>
                        <h2 className="title"> <em>시사 상식 마스터 까지!</em> </h2>
                     </div>
                  </a>
               </section>
            </main>
            <Footer />
         </>
      );
   }
}


async function setWord(md, idx) {
   const publicUrl = process.env.REACT_APP_POCKET_WWW;
   setCookie('JUMP_URI', publicUrl);
   try {
      const response = await axios.get('/api/setWord.php?md=' + md + '&idx=' + idx);
      if (response.data == 'NO') {
         //window.location.href = loginUrl + '?ref=' + pocketUrl + '/View/' + idx + '&zid=' + idx;
         const refUrl = process.env.REACT_APP_USER_WWW + '/snslogin/PocketLogingDone.php?loc=View/' + idx + '&idx=' + idx;
         window.location.href = loginUrl + '?ref=' + encodeURIComponent(refUrl);
      }
      return response.data;
   } catch (error) {
      console.log(error.message);
      return false;
   };
}
export default withRouter(WordView);